import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "slide", "dot"]
  static values = { interval: { type: Number, default: 6000 } }

  connect() {
    this.currentIndex = 0
    this.startAutoPlay()

    this.element.addEventListener("mouseenter", this.pause)
    this.element.addEventListener("mouseleave", this.resume)
    this.element.addEventListener("touchstart", this.pause, { passive: true })
    this.element.addEventListener("touchend", this.resumeAfterDelay)
  }

  disconnect() {
    this.stopAutoPlay()
    this.element.removeEventListener("mouseenter", this.pause)
    this.element.removeEventListener("mouseleave", this.resume)
    this.element.removeEventListener("touchstart", this.pause)
    this.element.removeEventListener("touchend", this.resumeAfterDelay)
  }

  goTo(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    this.showSlide(index)
    this.restartAutoPlay()
  }

  showSlide(index) {
    if (this.slideTargets.length === 0) return
    this.currentIndex = index % this.slideTargets.length
    this.trackTarget.style.transform = `translateX(-${this.currentIndex * 100}%)`
    this.updateDots()
  }

  next() {
    this.showSlide(this.currentIndex + 1)
  }

  updateDots() {
    this.dotTargets.forEach((dot, i) => {
      if (i === this.currentIndex) {
        dot.classList.add("bg-amber-400", "scale-125")
        dot.classList.remove("bg-white/30")
      } else {
        dot.classList.remove("bg-amber-400", "scale-125")
        dot.classList.add("bg-white/30")
      }
    })
  }

  startAutoPlay() {
    if (this.slideTargets.length <= 1) return
    this.timer = setInterval(() => this.next(), this.intervalValue)
  }

  stopAutoPlay() {
    if (this.timer) clearInterval(this.timer)
  }

  restartAutoPlay() {
    this.stopAutoPlay()
    this.startAutoPlay()
  }

  pause = () => {
    this.stopAutoPlay()
  }

  resume = () => {
    this.startAutoPlay()
  }

  resumeAfterDelay = () => {
    setTimeout(() => this.startAutoPlay(), 3000)
  }
}
